import { observer } from 'mobx-react';
import * as React from 'react';
import { currentUserStore } from '../../../CurrentUserStore';
import CreateCollectionButton from './CreateCollectionButton';
import { findLinkBy } from '../../../Links';

const AddCollectionViaOverlayLink: React.FC = () =>
  findLinkBy({ rel: 'preview-learning-collection-template-v2' }, currentUserStore.links)
    .map(() => <CreateCollectionButton />)
    .getOrElse(() => <></>);

export default observer(AddCollectionViaOverlayLink);
